import attendanceForm from 'translations/fr/employee/attendanceForm'
import availabilityForm from 'translations/fr/employee/availabilityForm'
import dailyQuestionnaire from 'translations/fr/employee/dailyQuestionnaire'
import myAttendance from 'translations/fr/employee/myAttendance'
import myAvailability from 'translations/fr/employee/myAvailability'
import myHome from 'translations/fr/employee/myHome'
import myMessages from 'translations/fr/employee/myMessages'
import myNotifications from 'translations/fr/employee/myNotifications'
import myProfile from 'translations/fr/employee/myProfile'
import mySchedule from 'translations/fr/employee/mySchedule'
import mySettings from 'translations/fr/employee/mySettings'
import myShiftOffers from 'translations/fr/employee/myShiftOffers'
import myTimeOff from 'translations/fr/employee/myTimeOff'
import punch from 'translations/fr/employee/punch'
import requestDetails from 'translations/fr/employee/requestDetails'
import requestStatus from 'translations/fr/employee/requestStatus'
import requestType from 'translations/fr/employee/requestType'
import timeOffForm from 'translations/fr/employee/timeOffForm'
import shiftConfirmation from 'translations/fr/employee/shiftConfirmation'
import attributeExpiration from 'translations/fr/employee/attributeExpiration'

export default {
  attendanceForm,
  availabilityForm,
  dailyQuestionnaire,
  myAttendance,
  myAvailability,
  myHome,
  myMessages,
  myNotifications,
  myProfile,
  mySchedule,
  mySettings,
  myShiftOffers,
  myTimeOff,
  punch,
  requestDetails,
  requestStatus,
  requestType,
  shiftConfirmation,
  attributeExpiration,
  timeOffForm
}
